import React, { useContext, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext, invitationLoadedFor } from '../Contexts/AuthContext';
import LoadingScreen from '../Components/Atoms/LoadingScreen';
import SignUp from './SignUp/Screen/SignUp';

// Entry of the open invitation link (QR code). Someone already signed in goes
// straight to the status of their request instead of the sign-up form.
const InvitationContainer = () => {
  const { invitationId = '' } = useParams();
  const { init, invitation, authReady, user, joining } = useContext(AuthContext);
  const navigate = useNavigate();
  // Only a session that existed when the page opened leads straight to the
  // status; a join on this page navigates itself once its request is sent.
  const hadSession = useRef<boolean | null>(null);
  if (authReady && hadSession.current === null) hadSession.current = !!user;

  useEffect(() => {
    if (invitationId) init(invitationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitationId]);

  useEffect(() => {
    if (!invitationLoadedFor(invitation, invitationId) || !authReady || joining) return;
    if (invitation.invalid) navigate(`/${invitationId}/error`, { replace: true });
    else if (user && hadSession.current) navigate(`/${invitationId}/waitingForAcceptance`, { replace: true });
  }, [invitation, authReady, user, joining, invitationId, navigate]);

  if (!invitationLoadedFor(invitation, invitationId) || !authReady || invitation.invalid || (user && hadSession.current)) {
    return <LoadingScreen loading />;
  }

  return <SignUp invitationId={invitationId} navigate={navigate} />;
};

export default InvitationContainer;
